define('presentation/settings/billing/billCycleToDate/viewModels/billCycleToDateViewModel',['businessServices/converters/numberFormatter',
        'common/promises/promiseFactory',
        'common/url/urlFormatter',
        'money',
        'businessServices/converters/currencyFormatter',
        'presentation/settings/billing/billCycleToDate/facades/billCycleToDateFacade',
        'settings/navigationConfiguration'
],
    function() {
        return function() {
            const self = this;

            const NumberFormatterConstructor = require('businessServices/converters/numberFormatter');
            let _numberFormatter = new NumberFormatterConstructor();

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            let _promiseFactory = new PromiseFactoryConstructor();

            const CurrencyFormatterConstructor = require('businessServices/converters/currencyFormatter');
            const _currencyFormatter = new CurrencyFormatterConstructor();

            const Money = require('money');
            const _navigationConfiguration = require('settings/navigationConfiguration');
            const _i18n = require('i18next');
            const _urlFormatter = require('common/url/urlFormatter');

            let _facade = null;

            const DETAILS_GROUP = {
                monthlyRecurringCharges: "monthlyRecurringCharges",
                monthlyRecurringChargesForLiveServices: "monthlyRecurringChargesForLiveServices",
                monthlyRecurringChargesForAutomatedServices: "monthlyRecurringChargesForAutomatedServices",
                plan: "plan",
                phoneNumbers: "phoneNumbers",
                outboundCallingPackageUsage: "outboundCallingPackageUsage",
                additionalOutreaches: "additionalOutreaches",
                receptionistPackageUsage: "receptionistPackageUsage",
                additionalLiveCallAnsweringMinutes: "additionalLiveCallAnsweringMinutes",
                startingBalance: "startingBalance",
                taxesAndFees: "taxesAndFees",
                adjustments: "adjustments",
                telephonyPackageUsage: "telephonyPackageUsage",
                additionalAutomatedMinutes: "additionalAutomatedMinutes",
                users: "users",
                scripts: "scripts",
                webChatPackageUsage: "webChatPackageUsage",
                additionalWebChats: "additionalWebChats",
                federalTaxes: "federalTaxes",
                stateTaxes: "stateTaxes",
                localTaxes: "localTaxes"
            };

            const TOTALS_GROUP = {
                estimatedBalance: "estimatedBalance",
                pendingPayment: "pendingPayment",
                pastDueBalance: "pastDueBalance",
                monthlyRecurringCharges: "monthlyRecurringCharges",
                monthlyRecurringChargesForLiveServices: "monthlyRecurringChargesForLiveServices",
                monthlyRecurringChargesForAutomatedServices: "monthlyRecurringChargesForAutomatedServices",
                currentUsage: "currentUsage",
                oneTimeCharges: "oneTimeCharges",
                currentTaxes: "currentTaxes"
            };

            const _amountTotal = (details) => {
                return ko.pureComputed(() => {
                    let total = new Money(0);
                    details().forEach((element) => {
                        if (element.includeInTotal !== false) {
                            total = total.plus(element.amount);
                        }
                    });
                    return total.toFixed(2);
                });
            };

            const _buildDetailGroup = (type) => {
                let group = {
                    header: ko.observable(""),
                    details: ko.observableArray([]),
                };
                group.total = _amountTotal(group.details);
                group.count = ko.pureComputed(() => group.details().length);
                group.countDisplay = ko.pureComputed(() => _numberFormatter.formatForDisplay(group.details().length));
                group.header = ko.pureComputed(() => {
                    let options = {
                        count: group.count(),
                        countDisplay: group.countDisplay()
                    };
                    if (type === "startingBalance") {
                        if (self.hasPastDueBalance()) {
                            type = "pastDueBalance";
                        }
                    }

                    if (type === DETAILS_GROUP.receptionistPackageUsage || type === DETAILS_GROUP.additionalLiveCallAnsweringMinutes) {
                        options.countDisplay = self.receptionistPackageMinutesUsed();
                    }
                    if (type === DETAILS_GROUP.telephonyPackageUsage || type === DETAILS_GROUP.additionalAutomatedMinutes) {
                        options.countDisplay = self.telephonyPackageMinutesUsed();
                    }
                    if (type === DETAILS_GROUP.outboundCallingPackageUsage || type === DETAILS_GROUP.additionalOutreaches) {
                        options.countDisplay = self.outboundCallingContactsUsed();
                    }
                    if (type === DETAILS_GROUP.webChatPackageUsage || type === DETAILS_GROUP.additionalWebChats) {
                        options.countDisplay = self.webChatsUsed();
                    }
                    return _i18n.t(`billCycleToDate:${type}:header`, options);
                });
                group.showNote = ko.pureComputed(() => {
                    return self.isLegacyBillFormat() === false && type === DETAILS_GROUP.additionalAutomatedMinutes;
                });
                group.note = ko.pureComputed(() => {
                    if (type === DETAILS_GROUP.additionalAutomatedMinutes) {
                        return _i18n.t(`billCycleToDate:${type}:note`);
                    }
                });
                return group;
            };

            const _buildTotalsGroup = (type) => {
                let group = {
                    header: ko.observable(""),
                    tooltip: ko.observable(""),
                    showTooltip: ko.observable(false),
                    startDate: ko.observable(""),
                    endDate: ko.observable(""),
                    amount: ko.observable(""),
                    processingDateDisplay: ko.observable(null),
                    billingPeriodDisplay: ko.observable(null)
                };
                group.header = ko.pureComputed(() => {
                    if (self.isLegacyBillFormat() === false) {
                        if (type === "estimatedBalance") {
                            if (self.isAccountInOnboarding() === true) {
                                type = "exampleBalance";
                            }
                        }
                    }
                    return _i18n.t(`billCycleToDate:${type}:totalsHeader`);
                });
                group.tooltip = ko.pureComputed(() => {
                    let options = {
                        processingDateDisplay: group.processingDateDisplay()
                    };
                    return _i18n.t(`billCycleToDate:${type}:tooltip`, options);
                });
                group.showTooltip = ko.pureComputed(() => {
                    return group.tooltip() !== "";
                });
                group.processingInfoDisplay = ko.pureComputed(() => {
                    if (self.isAccountInOnboarding() === true)
                    {
                        return;
                    }
                    let options = {
                        processingDateDisplay: group.processingDateDisplay()
                    };
                    return _i18n.t(`billCycleToDate:${type}:processingInfoDisplay`, options);
                });
                group.billingPeriodDisplay = ko.pureComputed(() => {
                    if (self.isAccountInOnboarding() === true)
                    {
                        return;
                    }
                    let options = {
                        startDate: group.startDate(),
                        endDate: group.endDate()
                    };
                    return _i18n.t(`billCycleToDate:${type}:billingPeriodDisplay`, options);
                });
                return group;
            };

            self.autoCharge = ko.observable(true);
            self.hasCurrentBalance = ko.observable();
            self.hasPastDueBalance = ko.observable();
            self.hasPendingPayment = ko.observable();
            self.pendingChargeAmount = ko.observable();
            self.estimatedChargesAmount = ko.observable();

            self.isInFreeTrial = ko.observable(false);
            self.numberOfDaysRemainingInFreeTrial = ko.observable();

            self.hasReceptionistPackage = ko.observable(false);
            self.receptionistPackageMinutesUsed = ko.observable(0);

            self.hasOutboundCallingPackage = ko.observable(false);
            self.outboundCallingContactsUsed = ko.observable(0);

            self.showTelephonyPackage = ko.pureComputed(() => {
                if (self.hasReceptionistPackage() === true)
                {
                    return false;
                }

                return self.hasTelephonyPackage() === true;
            });

            self.hasTelephonyPackage = ko.observable(false);
            self.telephonyPackageMinutesUsed = ko.observable(0);

            self.shouldDisplayScripts = ko.pureComputed(() => {
                if (self.hasReceptionistPackage() === true || self.hasWebChatPackage() === true || self.hasOutboundCallingPackage() === true)
                {
                    return true;
                }
                return self.scripts.length > 0;
            });
            self.shouldDisplayAdjustments = ko.pureComputed(() => {
                return self.adjustments.details().length > 0;
            });
            self.hasWebChatPackage = ko.observable(false);
            self.webChatsUsed = ko.observable(0);

            self.hasFederalTaxes = ko.pureComputed(() => {
                return self.federalTaxes.details().length > 0;
            });
            self.hasStateTaxes = ko.pureComputed(() => {
                return self.stateTaxes.details().length > 0;
            });
            self.hasLocalTaxes = ko.pureComputed(() => {
                return self.localTaxes.details().length > 0;
            });

            self.defaultPaymentMethod = {
                displayName: ko.observable(""),
                cssClass: ko.observable(""),
                lastFourDigits: ko.observable(""),
                expirationDate: ko.observable(""),
                shortDisplayName: ko.observable("")
            };

            self.displayPlan = ko.observable(false);
            self.monthlyRecurringChargesDetails = _buildDetailGroup(DETAILS_GROUP.monthlyRecurringCharges);
            self.monthlyRecurringChargesForLiveServicesDetails = _buildDetailGroup(DETAILS_GROUP.monthlyRecurringChargesForLiveServices);
            self.monthlyRecurringChargesForAutomatedServicesDetails = _buildDetailGroup(DETAILS_GROUP.monthlyRecurringChargesForAutomatedServices);
            self.plan = _buildDetailGroup(DETAILS_GROUP.plan);
            self.receptionistPackageUsage = _buildDetailGroup(DETAILS_GROUP.receptionistPackageUsage);
            self.additionalLiveCallAnsweringMinutes = _buildDetailGroup(DETAILS_GROUP.additionalLiveCallAnsweringMinutes);
            self.additionalAutomatedMinutes = _buildDetailGroup(DETAILS_GROUP.additionalAutomatedMinutes);
            self.outboundCallingPackageUsage = _buildDetailGroup(DETAILS_GROUP.outboundCallingPackageUsage);
            self.additionalOutreaches = _buildDetailGroup(DETAILS_GROUP.additionalOutreaches);
            self.webChatPackageUsage = _buildDetailGroup(DETAILS_GROUP.webChatPackageUsage);
            self.additionalWebChats = _buildDetailGroup(DETAILS_GROUP.additionalWebChats);
            self.telephonyPackageUsage = _buildDetailGroup(DETAILS_GROUP.telephonyPackageUsage);
            self.users = _buildDetailGroup(DETAILS_GROUP.users);
            self.scripts = _buildDetailGroup(DETAILS_GROUP.scripts);
            self.phoneNumbers = _buildDetailGroup(DETAILS_GROUP.phoneNumbers);
            self.startingBalance = _buildDetailGroup(DETAILS_GROUP.startingBalance);
            self.adjustments = _buildDetailGroup(DETAILS_GROUP.adjustments);
            self.taxes = _buildDetailGroup(DETAILS_GROUP.taxesAndFees);
            self.federalTaxes = _buildDetailGroup(DETAILS_GROUP.federalTaxes);
            self.stateTaxes = _buildDetailGroup(DETAILS_GROUP.stateTaxes);
            self.localTaxes = _buildDetailGroup(DETAILS_GROUP.localTaxes);

            self.isLegacyBillFormat = ko.observable(true);
            self.isAccountInOnboarding = ko.observable(false);

            self.monthlyRecurringChargesTotal = ko.pureComputed(() => {
                let total = new Money(0);
                total = total
                    .plus(self.monthlyRecurringChargesDetails.total());
                return total.toFixed(2);
            }).extend({deferred: true});

            self.monthlyRecurringChargesForLiveServicesTotal = ko.pureComputed(() => {
                let total = new Money(0);
                total = total
                    .plus(self.monthlyRecurringChargesForLiveServicesDetails.total());
                return total.toFixed(2);
            }).extend({deferred: true});

            self.monthlyRecurringChargesForAutomatedServicesTotal = ko.pureComputed(() => {
                let total = new Money(0);
                total = total
                    .plus(self.monthlyRecurringChargesForAutomatedServicesDetails.total());
                return total.toFixed(2);
            }).extend({deferred: true});

            self.currentTaxesTotal = ko.pureComputed(() => {
                let total = new Money(0);
                total = total
                    .plus(self.federalTaxes.total())
                    .plus(self.stateTaxes.total())
                    .plus(self.localTaxes.total());
                return total.toFixed(2);
            }).extend({deferred: true});

            self.currentUsageTotal = ko.pureComputed(() => {
                let total = new Money(0);
                total = total
                    .plus(self.outboundCallingPackageUsage.total())
                    .plus(self.receptionistPackageUsage.total())
                    .plus(self.telephonyPackageUsage.total())
                    .plus(self.webChatPackageUsage.total())
                    .plus(self.users.total())
                    .plus(self.scripts.total())
                    .plus(self.phoneNumbers.total())
                    .plus(self.adjustments.total())
                    .plus(self.taxes.total());
                return total.toFixed(2);
            }).extend({deferred: true});

            self.oneTimeChargesTotal = ko.pureComputed(() => {
                let total = new Money(0);
                total = total
                    .plus(self.additionalLiveCallAnsweringMinutes.total())
                    .plus(self.additionalAutomatedMinutes.total())
                    .plus(self.additionalOutreaches.total())
                    .plus(self.additionalWebChats.total())
                    .plus(self.phoneNumbers.total())
                    .plus(self.adjustments.total())
                    .plus(self.taxes.total());
                return total.toFixed(2);
            }).extend({deferred: true});

            self.estimatedBalanceTotal = ko.pureComputed(() => {
                if (self.isLegacyBillFormat() === false && self.isAccountInOnboarding() === true)
                {
                    let total = new Money(0);
                    total = total
                        .plus(self.monthlyRecurringChargesForAutomatedServicesTotal())
                        .plus(self.monthlyRecurringChargesForLiveServicesTotal())
                        .plus(self.oneTimeChargesTotal())
                        .plus(self.currentTaxesTotal());
                    return total.toFixed(2);
                }
                return self.estimatedChargesAmount();
            });

            self.estimatedBalance = _buildTotalsGroup(TOTALS_GROUP.estimatedBalance);
            self.pendingPayment = _buildTotalsGroup(TOTALS_GROUP.pendingPayment);
            self.pastDueBalance = _buildTotalsGroup(TOTALS_GROUP.pastDueBalance);
            self.monthlyRecurringCharges = _buildTotalsGroup(TOTALS_GROUP.monthlyRecurringCharges);
            self.monthlyRecurringChargesForLiveServices = _buildTotalsGroup(TOTALS_GROUP.monthlyRecurringChargesForLiveServices);
            self.monthlyRecurringChargesForAutomatedServices = _buildTotalsGroup(TOTALS_GROUP.monthlyRecurringChargesForAutomatedServices);
            self.currentUsage = _buildTotalsGroup(TOTALS_GROUP.currentUsage);
            self.oneTimeCharges = _buildTotalsGroup(TOTALS_GROUP.oneTimeCharges);
            self.currentTaxes = _buildTotalsGroup(TOTALS_GROUP.currentTaxes);

            self.autoCloseDateDisplay = ko.observable("");
            self.showAutoCloseWarning = ko.pureComputed(() => {
                return self.autoCloseDateDisplay() !== "";
            });

            self.makeAPaymentUrl = _urlFormatter.buildWorkSessionUrl(_navigationConfiguration.routesById.makeAPayment.url);
            self.changePaymentMethodUrl = _navigationConfiguration.routesById.paymentMethods.url;

            self.showProcessingInfoMethod = ko.pureComputed(() => {
                return self.autoCharge() && self.autoCloseDateDisplay() === "";
            });

            self.showPastDueBalance = ko.pureComputed(() => {
                return self.hasPastDueBalance();
            });

            self.showPendingPayment = ko.pureComputed(() => {
                return self.hasCurrentBalance() && !self.hasPastDueBalance();
            });

            self.isFreeTrialPendingOnboarding = ko.observable(false);

            self.showFreeTrialWarning = ko.pureComputed(() => {
                return self.isInFreeTrial()  || self.isFreeTrialPendingOnboarding();
            });

            self.freeTrialWarningTitle = ko.pureComputed(() => {
                if (self.isFreeTrialPendingOnboarding()) {
                    return _i18n.t('billCycleToDate:freeTrialNotStartedTitle');
                }
                let options = {
                    count: self.numberOfDaysRemainingInFreeTrial(),
                    freeTrialDaysRemaining: self.numberOfDaysRemainingInFreeTrial()
                };
                return _i18n.t('billCycleToDate:freeTrialWarningTitle', options);
            });

            self.freeTrialWarningMessage = ko.pureComputed(() => {
                if (self.isFreeTrialPendingOnboarding()) {
                    return _i18n.t('billCycleToDate:freeTrialNotStartedMessage');
                }
                let options = {
                    freeTrialEndDate: self.freeTrialEndDate()
                };
                return _i18n.t('billCycleToDate:freeTrialWarningMessage', options);
            });

            self.pastDueBalanceWarningMessage = ko.pureComputed(() => {
                let options = {
                    pastDueBalanceAmount: _currencyFormatter.formatUSDForDisplay(self.hasPastDueBalance() ? self.pastDueBalance.amount() : 0)
                };
                let message = _i18n.t('billCycleToDate:pastDueBalance_part1', options);
                message += '<a class="warning-box__message-link" href="' + self.makeAPaymentUrl + '">';
                message += _i18n.t('billCycleToDate:pastDueBalance_part2') + '</a>';
                message += _i18n.t('billCycleToDate:pastDueBalance_part3');
                return message;
            });

            self.freeTrialEndDate = ko.observable();

            const _getCurrentStatement = () => {
                _facade.getCurrentStatement()
                    .done((currentStatement) => {
                        self.isInFreeTrial(currentStatement.isInFreeTrial);
                        self.isFreeTrialPendingOnboarding(currentStatement.isFreeTrialPendingOnboarding);
                        self.freeTrialEndDate(currentStatement.freeTrialEndDate);
                        self.numberOfDaysRemainingInFreeTrial(currentStatement.numberOfDaysRemainingInFreeTrial);

                        self.startingBalance.details(currentStatement.startingBalance);

                        self.monthlyRecurringChargesDetails.details(currentStatement.monthlyRecurringCharges);
                        self.monthlyRecurringCharges.amount = self.monthlyRecurringChargesTotal;
                        self.monthlyRecurringCharges.startDate(currentStatement.nextCycleStartDate);
                        self.monthlyRecurringCharges.endDate(currentStatement.nextCycleEndDate);

                        self.monthlyRecurringChargesForLiveServicesDetails.details(currentStatement.monthlyRecurringChargesForLiveServices);
                        self.monthlyRecurringChargesForLiveServices.amount = self.monthlyRecurringChargesForLiveServicesTotal;
                        self.monthlyRecurringChargesForLiveServices.startDate(currentStatement.nextCycleStartDate);
                        self.monthlyRecurringChargesForLiveServices.endDate(currentStatement.nextCycleEndDate);

                        self.monthlyRecurringChargesForAutomatedServicesDetails.details(currentStatement.monthlyRecurringChargesForAutomatedServices);
                        self.monthlyRecurringChargesForAutomatedServices.amount = self.monthlyRecurringChargesForAutomatedServicesTotal;
                        self.monthlyRecurringChargesForAutomatedServices.startDate(currentStatement.nextCycleStartDate);
                        self.monthlyRecurringChargesForAutomatedServices.endDate(currentStatement.nextCycleEndDate);

                        self.currentUsage.amount = self.currentUsageTotal;
                        self.currentUsage.startDate(currentStatement.cycleStartDate);
                        self.currentUsage.endDate(currentStatement.cycleEndDate);

                        self.oneTimeCharges.amount = self.oneTimeChargesTotal;
                        self.oneTimeCharges.startDate(currentStatement.cycleStartDate);
                        self.oneTimeCharges.endDate(currentStatement.cycleEndDate);

                        self.estimatedBalance.amount = self.estimatedBalanceTotal;
                        self.estimatedBalance.processingDateDisplay(currentStatement.estimatedChargesProcessingDateDisplay);
                        self.estimatedBalance.startDate(currentStatement.cycleStartDate);
                        self.estimatedBalance.endDate(currentStatement.cycleEndDate);

                        self.defaultPaymentMethod.displayName(currentStatement.defaultPaymentMethod.displayCardNameAbbreviation);
                        self.defaultPaymentMethod.cssClass(currentStatement.defaultPaymentMethod.cssClass);
                        self.defaultPaymentMethod.lastFourDigits(currentStatement.defaultPaymentMethod.lastFourDigits);
                        self.defaultPaymentMethod.expirationDate(currentStatement.defaultPaymentMethod.expirationDate);
                        self.defaultPaymentMethod.shortDisplayName(currentStatement.defaultPaymentMethod.shortDisplayName);

                        self.autoCloseDateDisplay(currentStatement.pastDueBalanceAutoCloseDate);
                        self.autoCharge(!currentStatement.doNotAutoCharge);

                        self.hasPastDueBalance(currentStatement.hasPastDueBalance);
                        self.pastDueBalance.amount(currentStatement.pastDueBalance);
                        self.pastDueBalance.processingDateDisplay(currentStatement.currentBalanceProcessingDateDisplay);
                        self.pastDueBalance.startDate(currentStatement.pastDueBalanceCycleStartDate);
                        self.pastDueBalance.endDate(currentStatement.pastDueBalanceCycleEndDate);

                        self.hasCurrentBalance(currentStatement.hasCurrentBalance);
                        self.pendingPayment.amount(currentStatement.currentBalance);
                        self.pendingPayment.processingDateDisplay(currentStatement.currentBalanceProcessingDateDisplay);
                        self.pendingPayment.startDate(currentStatement.currentBalanceCycleStartDate);
                        self.pendingPayment.endDate(currentStatement.currentBalanceCycleEndDate);

                        self.pendingChargeAmount(currentStatement.currentBalance);
                        self.estimatedChargesAmount(currentStatement.estimatedCharges);

                        self.displayPlan(currentStatement.displayPlan);
                        self.plan.details(currentStatement.plan);

                        self.hasReceptionistPackage(currentStatement.hasReceptionistPackage);
                        self.receptionistPackageUsage.details(currentStatement.receptionistPackageUsage);
                        self.additionalLiveCallAnsweringMinutes.details(currentStatement.additionalLiveCallAnsweringMinutes);
                        self.receptionistPackageMinutesUsed(currentStatement.receptionistPackageMinutesUsed);

                        self.hasOutboundCallingPackage(currentStatement.hasOutboundCallingPackage);
                        self.outboundCallingPackageUsage.details(currentStatement.outboundCallingPackageUsage);
                        self.additionalOutreaches.details(currentStatement.additionalOutreaches);
                        self.outboundCallingContactsUsed(currentStatement.outboundCallingContactsUsed);

                        self.hasTelephonyPackage(currentStatement.hasTelephonyPackage);
                        self.telephonyPackageUsage.details(currentStatement.telephonyPackageUsage);
                        self.additionalAutomatedMinutes.details(currentStatement.additionalAutomatedMinutes);
                        self.telephonyPackageMinutesUsed(currentStatement.telephonyPackageMinutesUsed);

                        self.hasWebChatPackage(currentStatement.hasWebChatPackage);
                        self.webChatPackageUsage.details(currentStatement.webChatPackageUsage);
                        self.additionalWebChats.details(currentStatement.additionalWebChats);
                        self.webChatsUsed(currentStatement.webChatsUsed);

                        self.phoneNumbers.details(currentStatement.phoneNumbers);
                        self.users.details(currentStatement.users);
                        self.scripts.details(currentStatement.scripts);
                        self.taxes.details(currentStatement.taxesFeesSurcharges);

                        self.adjustments.details(currentStatement.adjustments);

                        self.currentTaxes.amount = self.currentTaxesTotal;
                        self.currentTaxes.startDate(currentStatement.cycleStartDate);
                        self.currentTaxes.endDate(currentStatement.cycleEndDate);

                        self.federalTaxes.details(currentStatement.currentFederalTaxes);
                        self.stateTaxes.details(currentStatement.currentStateTaxes);
                        self.localTaxes.details(currentStatement.currentLocalTaxes);

                        self.isLegacyBillFormat(currentStatement.isLegacyBillFormat);
                        self.isAccountInOnboarding(currentStatement.isAccountInOnboarding);
                    });
            };

            self.activate = () => {
                const Facade = require('presentation/settings/billing/billCycleToDate/facades/billCycleToDateFacade');
                _facade = new Facade();
                _facade.init(_promiseFactory);

                return _initialize();
            };

            const _initialize = () => {
                _getCurrentStatement();
                return _promiseFactory.wait();
            };
        };
    });

